import { render } from "./MyKitchen.vue?vue&type=template&id=47d0803e&scoped=true"
import script from "./MyKitchen.vue?vue&type=script&lang=js"
export * from "./MyKitchen.vue?vue&type=script&lang=js"

import "./MyKitchen.vue?vue&type=style&index=0&id=47d0803e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d0803e"]])

export default __exports__